import React from 'react';
import { withTranslation } from 'react-i18next';
import { Container, Grid, Paper, Typography, Button } from '@mui/material';
import { withStyles } from '@mui/styles';
import { withRouter, Link } from 'react-router-dom';
import DoneIcon from '@mui/icons-material/Done';
import { useParams } from 'react-router-dom/cjs/react-router-dom.min';
import WithContexts from '../../contexts/withContexts';
import { COLORS } from '../../utils/Application_Constants';

const styles = (theme) => ({
    root: {
        background: COLORS.LT_MIDNIGHTBG1,
        minHeight: '600px',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
    },
    ContainerRoot: {
        paddingTop: '2.5rem',
        paddingBottom: '2.5rem',
    },
    GridRoot: {
        minHeight: '300px',
    },
    doneIcon: {
        color: COLORS.LT_JOURNEY,
        background: COLORS.LT_JOURNEY10,
        borderRadius: '50%',
        padding: '16px',
    },
});

function ConfirmationDialog(props) {
    const { classes, t } = props;
    const { mode } = useParams();
    return (
        <div className={classes.root}>
            <Container maxWidth="lg" className={classes.ContainerRoot}>
                <Grid container justifyContent="center" alignItems="center">
                    <Grid item xs={10} sm={8} md={4}>
                        <Paper elevation={3}>
                            <Grid
                                container
                                direction="column"
                                spacing={2}
                                justifyContent="center"
                                alignItems="center"
                                className={classes.GridRoot}
                            >
                                <Grid item>
                                    <DoneIcon fontSize="large" className={classes.doneIcon} />
                                </Grid>
                                <Grid item>
                                    <Typography variant="h5">
                                        {mode == 'approved'
                                            ? t(
                                                  'submitTimesheet:HEADERS.TIMESHEET_APPROVED_CONFIRM'
                                              )
                                            : mode == 'rejected'
                                            ? t(
                                                  'submitTimesheet:HEADERS.TIMESHEET_REJECTED_CONFIRM'
                                              )
                                            : null}
                                    </Typography>
                                </Grid>
                                <Grid item>
                                    <Link to="/timesheets">
                                        <Button variant="contained" color="primary">
                                            {t('submitTimesheet:BUTTONS.DONE')}
                                        </Button>
                                    </Link>
                                </Grid>
                            </Grid>
                        </Paper>
                    </Grid>
                </Grid>
            </Container>
        </div>
    );
}

export default WithContexts(withRouter(withTranslation()(withStyles(styles)(ConfirmationDialog))));
